import kebabCase from 'lodash/kebabCase';

/**
 * generate a test id based an input object
 * @param {object} data - object of data
 * @returns {string} selector based on input
 */
export const makeId = function makeIdentifier(data) {
  return Object.keys(data)
    .sort()
    .map(key => kebabCase(data[key]))
    .join('_');
};
